import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    console.log("Timezone controller connected to:", this.element)
    console.log("Controller data attributes:", this.element.dataset)
    
    const alreadySet = localStorage.getItem("timezone_set")
    const aiOptionId = this.element.dataset.aiOptionsId

    if (!alreadySet) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      this.postTimezone(aiOptionId, timezone)
    }
  }

  detectTimezone(event) {
    event?.preventDefault()
    console.log("Detect timezone button clicked") // Debug log
    
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const aiOptionId = this.element.dataset.aiOptionsId

    // Find the timezone select by looking for the field name
    const select = this.element.querySelector('select[name*="timezone"]')
    
    if (select) {
      console.log("Found timezone select, current value:", select.value) // Debug log
      
      let found = false

      // Check if timezone option already exists
      for (const option of select.options) {
        if (option.value === timezone) {
          found = true
          break
        }
      }

      // Add new option if not found
      if (!found) {
        console.log("Adding new timezone option:", timezone) // Debug log
        const newOption = document.createElement("option")
        newOption.value = timezone
        newOption.text = timezone
        select.appendChild(newOption)
      }

      // Set the value
      select.value = timezone
      console.log("Set timezone to:", timezone) // Debug log
      
      // Trigger change event to notify other scripts
      select.dispatchEvent(new Event('change', { bubbles: true }))
    } else {
      console.error("Could not find timezone select element")
      console.log("Available selects:", this.element.querySelectorAll('select')) // Debug log
    }

    this.postTimezone(aiOptionId, timezone)
  }

  postTimezone(aiOptionId, timezone) {
    fetch(`/ai_options/${aiOptionId}/set_timezone`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({ timezone })
    })
      .then(response => {
        if (response.ok) {
          localStorage.setItem("timezone_set", "true")
          console.log("Timezone set:", timezone)
        } else {
          throw new Error(`HTTP ${response.status}`)
        }
      })
      .catch(error => {
        console.error("Failed to set timezone:", error)
      })
  }
}